import { useTranslation } from "react-i18next";
import Identity from "components/ContactFormVerification/Identity";
import HollowButton from "components/HollowButton";
import LoadingScreen from "components/LoadingScreen";
import { useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import styles from "./styles.module.scss";
import AuthLayout from "components/AuthLayout";
import { ESteps } from "components/Stepper";
import CompanyData from "components/ContactFormVerification/CompanyData";
import contactFormVerificationService from "api/contactFormVerificationService";
import { SignalRContext } from "./../../App";

export enum ActivationSteps {
  RecoveryKey = "recoveryKey",
  Identity = "identity",
  EDelivery = "edelivery",
  WelcomeBack = "welcomeBack",
  CompanyDetails = "companyDetails",
  CompanyVerificationInProgress = "companyVerificationInProgress",
  WaitingRequest = "waitingRequest",
}

const ContactFormVerificationModule = () => {
  const { t } = useTranslation();
  const { key } = useParams();

  const { data, isLoading, isError } =
    contactFormVerificationService.useGetVerification(key);

  const ContactFormVerificationSteps = [
    {
      type: ESteps.COMPANY_DATA,
      title: t("activation.stepper.companyData.title"),
      text: t("activation.stepper.companyData.description"),
    },
    {
      type: ESteps.ID_VERIFICATION,
      title: t("activation.stepper.dataVerification.title"),
      text: t("activation.stepper.dataVerification.description"),
    },
  ];

  const navigate = useNavigate();
  const [s, setS] = useState<ESteps>(ESteps.COMPANY_DATA);
  const [steps] = useState(ContactFormVerificationSteps);
  const [step, setStep] = useState<string>(ActivationSteps.CompanyDetails);

  const handleNextStep = () => {
    switch (step) {
      case ActivationSteps.Identity:
        break;
      case ActivationSteps.CompanyDetails:
        setStep(ActivationSteps.Identity);
        setS(ESteps.ID_VERIFICATION);
        break;
    }
  };

  const handlePrevStep = () => {
    switch (step) {
      case ActivationSteps.Identity:
        setStep(ActivationSteps.CompanyDetails);
        setS(ESteps.COMPANY_DATA);
        break;
      case ActivationSteps.CompanyDetails:
        break;
    }
  };

  const navigateToMainPage = () => {
    navigate("/home");
  };

  if (isLoading) {
    return <LoadingScreen></LoadingScreen>;
  }

  return (
    <AuthLayout
      actualStep={s}
      steps={steps}
      footerChildren={
        <div className={styles.footerLeft}>
          <HollowButton
            text={t("common.backHome")}
            onClick={() => navigateToMainPage?.()}
          ></HollowButton>
        </div>
      }
    >
      <>
        {isError && (
          <div>
            <div className={styles.wrapper2}>
              <div className={styles.header}>
                <div className={styles.title}>{t("errors.requestNotFound")}</div>
                <div className={styles.side}>
                  {t("validation.invalidLink")}
                </div>
              </div>
            </div>
          </div>
        )}

        {data?.data && step === ActivationSteps.Identity && (
          <Identity
            SignalRContext={SignalRContext}
            prevStep={handlePrevStep}
            nextStep={handleNextStep}
          ></Identity>
        )}
        {data?.data && step === ActivationSteps.CompanyDetails && (
          <CompanyData
            data={data?.data}
            nextStep={handleNextStep}
          ></CompanyData>
        )}
      </>
    </AuthLayout>
  );
};
export default ContactFormVerificationModule;
